import api from '../lib/axios';
import type { ApiResponse, LoginResponse, AuthUser } from '@maios/shared';

// CHG-141: 자동 합류 결과 — verify-email 응답에 포함
export interface AutoAcceptResult {
  status: 'accepted' | 'skipped';
  reason?: 'expired' | 'cancelled' | 'already_member' | 'limit_exceeded' | 'email_mismatch' | 'invitation_not_found';
  organizationId?: string;
  organizationName?: string;
  projectId?: string;
  projectKey?: string;
}

// CHG-060: register may return LoginResponse (skip mode) or { email } (verification mode)
// CHG-141: optional invitation token 동봉
export async function registerUser(data: {
  email: string;
  password: string;
  name: string;
  role?: string;
  pendingInvitationToken?: string;
  pendingInvitationType?: 'ORG' | 'PROJECT';
}) {
  const res = await api.post<ApiResponse<LoginResponse | { email: string }>>('/auth/register', data);
  return res.data;
}

// CHG-141 EDGE-006: 재발송 응답에 invitationCarriedOver / invitationStatusOnResend
export interface ResendVerificationResult {
  email: string;
  invitationCarriedOver: boolean;
  invitationStatusOnResend: 'PENDING' | 'EXPIRED' | 'ACCEPTED' | 'CANCELLED' | 'DECLINED' | null;
}

export async function resendVerification(email: string) {
  const res = await api.post<ApiResponse<ResendVerificationResult>>('/auth/resend-verification', { email });
  return res.data;
}

export async function verifyEmail(token: string) {
  const res = await api.get<ApiResponse<LoginResponse & { autoAccept: AutoAcceptResult | null }>>('/auth/verify-email', { params: { token } });
  return res.data.data!;
}

export async function loginUser(data: { email: string; password: string }) {
  const res = await api.post<ApiResponse<LoginResponse>>('/auth/login', data);
  return res.data.data!;
}

export async function logoutUser(refreshToken: string) {
  await api.post('/auth/logout', { refreshToken });
}

export async function getMe() {
  const res = await api.get<ApiResponse<AuthUser>>('/auth/me');
  return res.data.data!;
}
